<template>
  <Modal
    v-model="modal"
    footer-hide
    draggable
    scrollable
    :styles="{top: '280px'}"
    :transition-names="['load-bottom-fade', 'fade']"
    :transfer="false"
    class-name="ball-status-modal"
  >
    <p slot="header">
      <span>{{modalText}}</span>
      <span>{{modalItems.status == 1 ? '成功' : '失敗'}}</span>
    </p>
    <div v-for="it in modalItems.linkstie" class="lida-card-alert" :class="[alertClass(it)]">
      <p>站点:{{it.memname}}</p>
      <template v-if="it.msg">
        <div class="ml-2" v-if="it.msg.status">
          <template v-if="modalClassStatus == 1">
            <p v-for="item in it.msg.success">號碼{{item}}設置成功</p>
          </template>
          <template v-if="modalClassStatus == 2">結算成功</template>
          <template v-if="modalClassStatus == 3">重新結算成功</template>
          <template v-if="modalClassStatus == 4">反結算成功</template>
        </div>
        <div class="ml-2" v-if="!it.msg.status">
          <template>{{it.msg.msg}}</template>
          <!-- <template v-if="modalClassStatus == 4">反結算失敗</template> -->
        </div>
      </template>
      <template v-else>网路异常：(S6013)</template>
    </div>
  </Modal>
</template>
<script>
export default {
  data () {
    return {
      modalStatus: false,
      modalItems: {},
      modalClassStatus: null,
    }
  },
  computed: {
    modal: {
      get () {
        return this.modalStatus
      },
      set (val) {
        this.modalStatus = val
      }
    },
    modalText () {
      let result
      switch (this.modalClassStatus) {
        case '1':
          result = '設定號碼'
          break;
        case '2':
          result = '結算'
          break;
        case '3':
          result = '重新結算'
          break;
        case '4':
          result = '反結算'
          break;
        default:

          break;
      }
      return result
    }
  },
  methods: {
    settingBall (status, items, index) {
      this.settingStatus(status)
      this.settingItems(items)
      this.settingClassStatus(index)
      setTimeout(() => this.settingStatus(false), 10000)
    },
    settingStatus (val) {
      this.modalStatus = val
    },
    settingItems (val) {
      this.modalItems = val
    },
    settingClassStatus (val) {
      this.modalClassStatus = val
    },
    alertClass (it) {
      if (it.msg === null) return { 'error': true }
      return it.msg.status === 1
        ? { 'success': true }
        : { 'warning': true }
    }
  }
}
</script>
<style lang="scss">
.ball-status-modal {
  .ivu-modal-content {
    left: 0;
  }
}
.load-bottom-fade-enter-active,
.load-bottom-fade-leave-active {
  transition: all 0.3s ease-in-out;
}
.load-bottom-fade-enter {
  transform: translateY(250px);
}
.load-bottom-fade-leave-to {
  transform: translateY(250px);
}
</style>